import { DownloadOutlined, EditOutlined, LockOutlined, SaveOutlined, SearchOutlined, SendOutlined, ArrowLeftOutlined, ReloadOutlined, DeleteOutlined, FileExcelOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, InputNumber, Row, Space, Tabs, Select, DatePicker } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ContentHeader } from '../../components';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { formatVND, validateMessages } from '../../helpers/common';
import dayjs, { Dayjs } from 'dayjs';
import { ChiTietLuongBoSungTruongBKSItem, LuongBoSungTruongBKSInfo } from '../../models/luong/LuongBoSungTruongBKS';
import TableChiTietLuongBoSungTruongBKS from '../../modules/salary/TableChiTietLuongBoSungTruongBKS';
import SelectThamChieuLuongCoBanBSTBKS from '../../modules/salary/SelectThamChieuLuongCoBanBSTBKS';
import { layDsLuongCoBanChoLuongBSTBKS, layDsLuongBoSungTruongBKSTheoNam, capNhatQuyLuongBoSungTruongBKS, chiTietLuongBoSungTruongBKS, duyetLuongBoSungTruongBKS, layThongTinLuongBoSungTruongBKS, luuDieuChinhChiTietLuongBoSungTruongBKS, luuLuongBoSungTruongBKS, taiDuLieuLuongBoSungTruongBKS, xoaBangLuongBoSungTruongBKS, xuatExcelLuongBoSungTruongBKS } from '../../services/luong';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { Links } from '../../helpers/Links';

const ChiTietLuongBoSungTruongBKS = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const [form] = Form.useForm();

    const [id, setId] = useState<number>(0);
    const [info, setInfo] = useState<LuongBoSungTruongBKSInfo | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [tuKhoa, setTuKhoa] = useState<string>('');

    const [data, setData] = useState<ChiTietLuongBoSungTruongBKSItem[]>([]);
    const [rawData, setRawData] = useState<ChiTietLuongBoSungTruongBKSItem[]>([]);

    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [changedRowIds, setChangedRowIds] = useState<Set<number>>(new Set());
    const [reload, setReload] = useState<boolean>(false);
    const [isShowModalDuyet, setIsShowModalDuyet] = useState<boolean>(false);
    const [isShowModalCapNhat, setIsShowModalCapNhat] = useState<boolean>(false);
    const [isShowModalXoa, setIsShowModalXoa] = useState<boolean>(false);
    const [ghiChu, setGhiChu] = useState<string>('');

    const [dsLuongCoBan, setDsLuongCoBan] = useState<any[]>([]);
    const [dsLuongBoSung, setDsLuongBoSung] = useState<any[]>([]);
    const [namLocLuongCoBan, setNamLocLuongCoBan] = useState<Dayjs | null>(null);
    const [namLocLuongBoSung, setNamLocLuongBoSung] = useState<Dayjs | null>(null);

    const layDsLuongCoBanModal = async (nam?: number) => {
        try {
            const rs = await layDsLuongCoBanChoLuongBSTBKS(nam);
            setDsLuongCoBan(rs ?? []);
        } catch (err: any) {
            toast.error(err?.toString().replace("Error: ", ""));
        }
    };

    const layDsLuongBoSungModal = async (nam?: number) => {
        try {
            const rs = await layDsLuongBoSungTruongBKSTheoNam(nam);
            const currentId = id || info?.id;
            const data = (rs ?? []).filter((x: any) => x.id !== currentId);
            setDsLuongBoSung(data);
        } catch (err: any) {
            toast.error(err?.toString().replace("Error: ", ""));
        }
    };

    const onChangeNamLocLuongCoBan = async (date: Dayjs | null) => {
        setNamLocLuongCoBan(date);
        form.setFieldsValue({ idsLuongCoBan: [] });
        await layDsLuongCoBanModal(date ? date.year() : undefined);
    };

    const onChangeNamLocLuongBoSung = async (date: Dayjs | null) => {
        setNamLocLuongBoSung(date);
        form.setFieldsValue({ idsLuongBoSung: [] });
        await layDsLuongBoSungModal(date ? date.year() : undefined);
    };


    const setChiTiet = (items: ChiTietLuongBoSungTruongBKSItem[]) => {
        setRawData(items);
        setData(items);
    };

    const layThongTin = async (salaryId: number) => {
        dispatch(showLoadingScreen());
        setLoading(true);
        try {
            const rs = await layThongTinLuongBoSungTruongBKS(salaryId);
            setInfo(rs);
            setGhiChu(rs?.ghiChu ?? '');

            const ct = await chiTietLuongBoSungTruongBKS(salaryId);
            setChiTiet(ct ?? []);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        setLoading(false);
        dispatch(hideLoadingScreen());
    };

    const handleTinh = async () => {
        dispatch(showLoadingScreen());
        setLoading(true);
        try {
            const ct = await taiDuLieuLuongBoSungTruongBKS(id);
            setChiTiet(ct ?? []);
            setChangedRowIds(new Set());
            setIsEdit(false);
            toast.success('Tính lương bổ sung Trưởng BKS thành công');
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        setLoading(false);
        dispatch(hideLoadingScreen());
    };

    const handleLuu = async () => {
        dispatch(showLoadingScreen());
        try {
            await luuLuongBoSungTruongBKS({ id, ghiChu, chiTiet: rawData });
            toast.success('Lưu lương bổ sung Trưởng BKS thành công');
            setReload(true);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleDuyet = async () => {
        dispatch(showLoadingScreen());
        try {
            await duyetLuongBoSungTruongBKS(id);
            toast.success('Xác nhận lương bổ sung Trưởng BKS thành công');
            setIsShowModalDuyet(false);
            setReload(true);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleXoa = async () => {
        dispatch(showLoadingScreen());
        try {
            await xoaBangLuongBoSungTruongBKS(id);
            toast.success('Xóa bảng lương bổ sung Trưởng BKS thành công');
            navigate(Links.Luong.DanhSachLuongBoSungTruongBKS);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleExportExcel = async () => {
        if (!id) return;
        dispatch(showLoadingScreen());
        try {
            const res = await xuatExcelLuongBoSungTruongBKS(id);
            if (res && res.data) {
                const blob = new Blob([res.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `${info?.tenKyLuong ?? 'Luong_Bo_Sung_Truong_BKS'}.xlsx`;
                link.click();
                window.URL.revokeObjectURL(link.href);
            }
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', '') || 'Xuất Excel thất bại');
        }
        dispatch(hideLoadingScreen());
    };

    const onChangeItem = (index: number, field: string, value: any) => {
        if (field !== 'soTienDuocNhan') return;

        const updated = [...data];
        const row = { ...updated[index], soTienDuocNhan: Number(value) || 0 };
        updated[index] = row;
        setData(updated);

        // Chênh lệch quỹ lương sẽ tự cập nhật vì được tính lại từ rawData ở phần render.
        const full = [...rawData];
        const idx = full.findIndex((x) => x.id === row.id);
        if (idx >= 0) {
            full[idx] = row;
            setRawData(full);
        }

        setChangedRowIds((prev) => {
            const ns = new Set(prev);
            ns.add(row.id);
            return ns;
        });
    };

    const handleLuuDieuChinh = async () => {
        if (changedRowIds.size === 0) {
            toast.warning('Không có dữ liệu thay đổi!');
            return;
        }

        dispatch(showLoadingScreen());
        try {
            const items = rawData
                .filter((x) => changedRowIds.has(x.id))
                .map((x) => ({
                    id: x.id,
                    soTienDuocTamUng: x.soTienDuocTamUng,
                    soTienDaTamUng: x.soTienDaTamUng,
                    soTienDuocNhan: x.soTienDuocNhan,
                    tyLeTamUng: x.tyLeTamUng,
                    soThangLamViec: x.soThangLamViec,
                    luongCoBanDaChi: x.luongCoBanDaChi,
                    luongBoSungDaChi: x.luongBoSungDaChi,
                    ghiChu: x.ghiChu
                }));

            await luuDieuChinhChiTietLuongBoSungTruongBKS({ items });

            toast.success(`Lưu điều chỉnh thành công (${items.length} dòng)`);
            setChangedRowIds(new Set());
            setIsEdit(false);
            setReload(true);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    
    const onFinishCapNhatQuyLuong = async (values: any) => {
        dispatch(showLoadingScreen());
        try {
            const request = {
                id: id,
                quyLuong: values?.quyLuong,
                tenKyLuong: values?.tenKyLuong,
                idsLuongCoBan: (values?.idsLuongCoBan ?? []).join(','),
                idsLuongBoSung: (values?.idsLuongBoSung ?? []).join(','),
                tyLeTamUng: info?.loai === 2 ? 100 : (values?.tyLeTamUng ?? 100),
                soThangLamViec: values?.soThangLamViec
            };
            await capNhatQuyLuongBoSungTruongBKS(request);

            toast.success('Cập nhật dữ liệu tham chiếu thành công!');
            setIsShowModalCapNhat(false);

            // Refresh dữ liệu
            await layThongTin(id);

            // Tính lại lương
            await handleTinh();
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const search = () => {
        const kw = (tuKhoa || '').toLowerCase();

        setData(
            rawData.filter(
                (x) =>
                    !kw ||
                    (x.hoTen ?? '').toLowerCase().includes(kw) ||
                    (x.ma ?? '').toLowerCase().includes(kw) ||
                    (x.tenDonVi ?? '').toLowerCase().includes(kw)
            )
        );
    };

    
    const onMoModalCapNhatQuyLuong = async () => {
        const namKy = info?.nam ? dayjs().year(info.nam) : (info?.thangNam ? dayjs(info.thangNam) : dayjs());
        
        let initialNamLocLuongCoBan: Dayjs | null = namKy;
        if (info?.idsLuongCoBan && info.idsLuongCoBan.trim().length > 0) {
            initialNamLocLuongCoBan = null;
        }

        let initialNamLocLuongBoSung: Dayjs | null = namKy;
        if (info?.idsLuongBoSung && info.idsLuongBoSung.trim().length > 0) {
            initialNamLocLuongBoSung = null;
        }

        setNamLocLuongCoBan(initialNamLocLuongCoBan);
        setNamLocLuongBoSung(initialNamLocLuongBoSung);

        await Promise.all([
            layDsLuongCoBanModal(initialNamLocLuongCoBan ? initialNamLocLuongCoBan.year() : undefined),
            layDsLuongBoSungModal(initialNamLocLuongBoSung ? initialNamLocLuongBoSung.year() : undefined)
        ]);

        form.setFieldsValue({
            quyLuong: info?.quyLuong,
            tenKyLuong: info?.tenKyLuong,
            loai: info?.loai,
            nam: info?.nam,
            idsLuongCoBan: info?.idsLuongCoBan ? info.idsLuongCoBan.split(',') : [],
            idsLuongBoSung: info?.idsLuongBoSung ? info.idsLuongBoSung.split(',') : [],
            soThangLamViec: info?.soThangLamViec,
            tyLeTamUng: info?.tyLeTamUng ?? 100
        });

        setIsShowModalCapNhat(true);
    };


    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const salaryId = urlParams.get('id');

        if (salaryId) {
            setId(Number(salaryId));
            layThongTin(Number(salaryId));
        }
    }, [location.search]);

    useEffect(() => {
        if (reload && id > 0) {
            setReload(false);
            layThongTin(id);
        }
    }, [reload]);

    const isDaDuyet = (info?.trangThai ?? 0) === 1;

    const coDuLieuDaLuu = rawData.length > 0 && rawData.some((x) => x.id > 0);
    const coTheDieuChinh = !isDaDuyet && coDuLieuDaLuu;

    const tongNhanSu = rawData.length;
    const tongDaTamUng = rawData.reduce((s, x) => s + (x.soTienDaTamUng ?? 0), 0);
    const tongTienDuocNhan = rawData.reduce((s, x) => s + (x.soTienDuocNhan ?? 0), 0);
    const quyLuong = info?.quyLuong ?? 0;
    const chenhLechQuyLuong = Math.round(quyLuong - tongTienDuocNhan);

    return (
        <section>
            <ContentHeader title={info?.tenKyLuong ?? 'Lương bổ sung Trưởng BKS'} />

            <Row className="form-group" gutter={8}>
                <Col xs={22} sm={14} md={8}>
                    <Input
                        prefix={<SearchOutlined />}
                        placeholder="Nhập tên, mã nhân viên, đơn vị"
                        value={tuKhoa}
                        onChange={(e) => setTuKhoa(e.target.value)}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') search();
                        }}
                    />
                </Col>

                <Col xs={2} sm={2} md={0}>
                    <Button type="primary" icon={<SearchOutlined />} onClick={search} />
                </Col>

                <Col xs={0} sm={0} md={4}>
                    <Button type="primary" icon={<SearchOutlined />} onClick={search}>
                        Tìm kiếm
                    </Button>
                </Col>

                <Col xs={24} sm={24} md={12}>
                    <Space className="float-right">
                        <Button type="default" icon={<ArrowLeftOutlined />} onClick={() => { navigate(Links.Luong.DanhSachLuongBoSungTruongBKS) } }>
                                Quay lại
                        </Button>
                        {!isDaDuyet && (
                            <Button
                                danger
                                type="primary"
                                icon={<DeleteOutlined />}
                                onClick={() => setIsShowModalXoa(true)}
                            >
                                Xóa dữ liệu
                            </Button>
                        )}
                        {!isDaDuyet && (
                            <Button type="primary" icon={<ReloadOutlined />} onClick={onMoModalCapNhatQuyLuong}>
                                Điều chỉnh mức tiền
                            </Button>
                        )}
                        {!isDaDuyet && (
                            <Button type="primary" icon={<DownloadOutlined />} onClick={handleTinh}>
                                Tính lương
                            </Button>
                        )}

                        {!isDaDuyet && (
                            <Button
                                type="primary"
                                icon={<SendOutlined />}
                                onClick={() => setIsShowModalDuyet(true)}
                            >
                                Xác nhận
                            </Button>
                        )}

                        {!isDaDuyet && (
                            <Button
                                className="hrm-btn hrm-btn-warning"
                                icon={<SaveOutlined />}
                                onClick={handleLuu}
                            >
                                Lưu
                            </Button>
                        )}
                        <Button
                            className="hrm-btn hrm-btn-success"
                            icon={<FileExcelOutlined />}
                            onClick={handleExportExcel}
                        >
                            Xuất Excel
                        </Button>
                    </Space>
                </Col>
            </Row>

            <Row gutter={8} className="form-group">
                <Col xs={24} sm={8} md={5}>
                    <div className="card card-primary" style={{ padding: '10px' }}>
                        <div className="text-center" style={{ fontSize: '12px' }}>
                            Mức tiền lương/tháng được tạm ứng
                        </div>
                        <div className="text-bold text-center">{formatVND(quyLuong)}</div>
                    </div>
                </Col>

                <Col xs={24} sm={8} md={5}>
                    <div className="card card-primary" style={{ padding: '10px' }}>
                        <div className="text-center" style={{ fontSize: '12px' }}>
                            Tổng đã tạm ứng
                        </div>
                        <div className="text-bold text-center">{formatVND(tongDaTamUng)}</div>
                    </div>
                </Col>

                <Col xs={24} sm={8} md={5}>
                    <div className="card card-primary" style={{ padding: '10px' }}>
                        <div className="text-center" style={{ fontSize: '12px' }}>
                            Tổng tiền được nhận
                        </div>
                        <div className="text-bold text-center">{formatVND(tongTienDuocNhan)}</div>
                    </div>
                </Col>

                <Col xs={24} sm={8} md={4}>
                    <div className="card card-primary" style={{ padding: '10px' }}>
                        <div className="text-center" style={{ fontSize: '12px' }}>
                            Số nhân sự
                        </div>
                        <div className="text-bold text-center">{tongNhanSu}</div>
                    </div>
                </Col>

                <Col xs={24} sm={16} md={5}>
                    <div className="card card-primary" style={{ padding: '10px' }}>
                        <div className="text-center" style={{ fontSize: '12px' }}>
                            Trạng thái
                        </div>
                        <div className="text-bold text-center">
                            {isDaDuyet ? (
                                <span style={{ color: '#52c41a' }}>Đã xác nhận</span>
                            ) : (
                                <span style={{ color: '#faad14' }}>Chưa xác nhận</span>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>

            <Row gutter={8} className="form-group">
                <Col span={24}>
                    <div className="card card-primary" style={{ padding: '15px' }}>
                        <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px' }}>Ghi chú</div>
                        {!isDaDuyet ? (
                            <Input.TextArea
                                rows={3}
                                placeholder="Nhập ghi chú..."
                                value={ghiChu}
                                onChange={(e) => setGhiChu(e.target.value)}
                            />
                        ) : (
                            <div style={{ whiteSpace: 'pre-wrap', minHeight: '40px', background: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
                                {ghiChu || 'Không có ghi chú'}
                            </div>
                        )}
                    </div>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <div className="card-outline">
                        <Tabs
                            tabBarExtraContent={<></>
                                // <Space>
                                //     {coTheDieuChinh && (
                                //         <Button
                                //             style={{ width: '140px' }}
                                //             type="default"
                                //             onClick={() => {
                                //                 if (isEdit && changedRowIds.size > 0) {
                                //                     layThongTin(id);
                                //                     setChangedRowIds(new Set());
                                //                 }

                                //                 setIsEdit(!isEdit);
                                //             }}
                                //             icon={
                                //                 isEdit ? (
                                //                     <LockOutlined style={{ color: 'red' }} />
                                //                 ) : (
                                //                     <EditOutlined style={{ color: '#007bff' }} />
                                //                 )
                                //             }
                                //         >
                                //             {isEdit ? 'Khóa' : 'Điều chỉnh'}
                                //         </Button>
                                //     )}

                                //     {isEdit && changedRowIds.size > 0 && (
                                //         <Button
                                //             className="hrm-btn hrm-btn-warning"
                                //             icon={<SaveOutlined />}
                                //             onClick={handleLuuDieuChinh}
                                //         >
                                //             Lưu điều chỉnh ({changedRowIds.size})
                                //         </Button>
                                //     )}
                                // </Space>
                            }
                            defaultActiveKey="1"
                            items={[
                                {
                                    key: '1',
                                    label: 'Bảng lương bổ sung Trưởng BKS',
                                    children: (
                                        <TableChiTietLuongBoSungTruongBKS
                                            loading={loading}
                                            dataSource={data}
                                            isEdit={isEdit}
                                            loai={info?.loai}
                                            onChangeItem={onChangeItem}
                                        />
                                    ),
                                },
                            ]}
                        />
                    </div>
                </Col>
            </Row>

            {isShowModalCapNhat && (
                <ModalTextForm
                    title={info?.loai === 1 || info?.loai === 2 ? "Điều chỉnh thông tin" : "Điều chỉnh Mức tiền lương/tháng được tạm ứng"}
                    hideFooter
                    show={isShowModalCapNhat}
                    handleClose={() => setIsShowModalCapNhat(false)}
                >
                    <Form
                        layout="vertical"
                        validateMessages={validateMessages}
                        onFinish={onFinishCapNhatQuyLuong}
                        form={form}
                    >
                        {(info?.loai === 1 || info?.loai === 2) && (
                            <Row gutter={8}>
                                <Col span={24}>
                                    <Form.Item label="Tên kỳ lương bổ sung" name="tenKyLuong" rules={[{ required: true, message: 'Vui lòng nhập tên kỳ lương bổ sung' }]}>
                                        <Input placeholder="Nhập tên kỳ lương bổ sung..." />
                                    </Form.Item>
                                </Col>
                            </Row>
                        )}
                        <Row gutter={8}>
                            <Col span={24}>
                                <Form.Item label={"Mức tiền lương/tháng được tạm ứng"} name="quyLuong" rules={[{ required: true }]}>
                                    <InputNumber
                                        min={0}
                                        step={1000}
                                        style={{ width: '100%' }}
                                        formatter={(val) => `${val}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={(val) => Number(`${val}`.replace(/,/g, '')) || 0}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        {(info?.loai === 1 || info?.loai === 2) && (
                            <>
                                <Row gutter={8}>
                                    <Col span={info?.loai === 1 ? 12 : 24}>
                                        <Form.Item label="Số tháng làm việc" name="soThangLamViec" rules={[{ required: true, message: 'Vui lòng nhập số tháng' }]}>
                                            <InputNumber min={0} max={12} step={0.5} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    {info?.loai === 1 && (
                                        <Col span={12}>
                                            <Form.Item label="Tỷ lệ tạm ứng (%)" name="tyLeTamUng" rules={[{ required: true, message: 'Vui lòng nhập tỷ lệ' }]}>
                                                <InputNumber min={0} max={100} style={{ width: '100%' }} />
                                            </Form.Item>
                                        </Col>
                                    )}
                                </Row>
                                <Row gutter={8}>
                                    <Col span={8}>
                                        <Form.Item label="Năm lương cơ bản">
                                            <DatePicker
                                                changeOnBlur={true}
                                                picker="year"
                                                placeholder="Năm (để trống = tất cả)"
                                                style={{ width: "100%" }}
                                                value={namLocLuongCoBan}
                                                onChange={onChangeNamLocLuongCoBan}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={16}>
                                        <Form.Item label="Tham chiếu Lương cơ bản" name="idsLuongCoBan">
                                            <SelectThamChieuLuongCoBanBSTBKS
                                                dataSource={dsLuongCoBan}
                                                placeholder="Chọn kỳ lương cơ bản"
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={8}>
                                    <Col span={8}>
                                        <Form.Item label="Năm lương bổ sung">
                                            <DatePicker
                                                changeOnBlur={true}
                                                picker="year"
                                                placeholder="Năm (để trống = tất cả)"
                                                style={{ width: "100%" }}
                                                value={namLocLuongBoSung}
                                                onChange={onChangeNamLocLuongBoSung}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={16}>
                                        <Form.Item label="Tham chiếu Lương bổ sung" name="idsLuongBoSung">
                                            <Select
                                                mode="multiple"
                                                placeholder="Chọn kỳ lương bổ sung"
                                                options={dsLuongBoSung.map((x: any) => ({ label: x.tenKyLuong, value: x.id.toString() }))}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </>
                        )}
<Form.Item>
                            <Button
                                type="primary"
                                className="float-right"
                                htmlType="submit"
                                icon={<SaveOutlined />}
                            >
                                Cập nhật
                            </Button>
                        </Form.Item>
                    </Form>
                </ModalTextForm>
            )}

            <ModalTextForm
                show={isShowModalDuyet}
                title="Xác nhận lương bổ sung Trưởng BKS"
                handleClose={() => setIsShowModalDuyet(false)}
                handleSave={handleDuyet}
            >
                Bạn có chắc muốn xác nhận lương bổ sung Trưởng BKS{' '}
                <b>{info?.tenKyLuong ?? ''}</b> không?
            </ModalTextForm>

            <ModalTextForm
                show={isShowModalXoa}
                title="Xóa bảng lương bổ sung Trưởng BKS"
                handleClose={() => setIsShowModalXoa(false)}
                handleSave={handleXoa}
            >
                Bạn có chắc chắn muốn xóa bảng lương bổ sung Trưởng BKS <b>{info?.tenKyLuong ?? ''}</b>? Hành động này sẽ xóa toàn bộ dữ liệu chi tiết của bảng lương.
            </ModalTextForm>
        </section>
    );
};

export default ChiTietLuongBoSungTruongBKS;